import JsPDF from "jspdf";
import html2canvas from "html2canvas";

class DocService {
  createPdf = (html, title = "Document") => {
    html2canvas(html, { scale: 2, windowWidth: 1200 }).then((canvas) => {
      const doc = new JsPDF();
      const imgData = canvas.toDataURL("image/png");
      const imgHeight = (canvas.height * 208) / canvas.width;
      doc.addImage(imgData, 0, 20, 208, imgHeight);
      doc.save(`${title}.pdf`);
      // window.open(doc.output('bloburl'))
      // { filename: `${title}.pdf` }
    });
  };
}

const Doc = new DocService();
export default Doc;
